import { render, staticRenderFns } from "./Rastreamento.vue?vue&type=template&id=5a197b6e&scoped=true"
import script from "./Rastreamento.vue?vue&type=script&lang=js"
export * from "./Rastreamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a197b6e",
  null
  
)

export default component.exports